import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { AadeBookInvoiceType } from '../../../../interfaces/myData.interface';

interface Props {
  doc: AadeBookInvoiceType;
}

export const GsisDocPaymentMethods = ({ doc }: Props) => {
  const { t } = useTranslation();

  const methods = useMemo(() => {
    const pm = doc?.paymentMethods?.paymentMethodDetails;
    if (!pm) return [];
    return Array.isArray(pm) ? pm : [pm];
  }, [doc?.paymentMethods]);

  if (!methods.length) return null;

  return (
    <div className="simpleBorder p-12 width-100">
      <div className="boldText5 margin-b-8">{t('DELIVERY.PAYMENT_METHODS')}</div>

      {methods.map((m, idx) => (
        <div key={idx} className="flex-start-start-row-wrap gap-12 margin-b-6">
          <div className="flex-start-center-row-nowrap">
            <div className="boldText4 padding-r-4">{t('DELIVERY.PAYMENT_TYPE')}:</div>
            <div className="normalText4">
              {t(`DELIVERY.PAYMENT_TYPE_${m.type}`, { defaultValue: String(m.type) })}
            </div>
          </div>
          <div className="flex-start-center-row-nowrap">
            <div className="boldText4 padding-r-4">{t('DELIVERY.PAYMENT_AMOUNT')}:</div>
            <div className="normalText4">{m.amount}</div>
          </div>
          {m.paymentMethodInfo && (
            <div className="flex-start-center-row-nowrap">
              <div className="boldText4 padding-r-4">{t('DELIVERY.PAYMENT_INFO')}:</div>
              <div className="normalText4">{m.paymentMethodInfo}</div>
            </div>
          )}
          {m.tipAmount != null && m.tipAmount > 0 && (
            <div className="flex-start-center-row-nowrap">
              <div className="boldText4 padding-r-4">{t('DELIVERY.TIP_AMOUNT')}:</div>
              <div className="normalText4">{m.tipAmount}</div>
            </div>
          )}
          {m.transactionId && (
            <div className="flex-start-center-row-nowrap">
              <div className="boldText4 padding-r-4">{t('DELIVERY.TRANSACTION_ID')}:</div>
              <div className="normalText4">{m.transactionId}</div>
            </div>
          )}
          {m.tid && (
            <div className="flex-start-center-row-nowrap">
              <div className="boldText4 padding-r-4">{t('DELIVERY.TID')}:</div>
              <div className="normalText4">{m.tid}</div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
